import { defineComponent as _defineComponent } from 'vue'
import ResourceImage from '@/components/base/ResourceImage.vue';
import DisableableButton from '@/components/buttons/DisableableButton.vue';
import downloadMedia from '@/mixins/downloadMedia';
import uploadMedia from '@/mixins/uploadMedia';
import type { ImageV1 } from '@ilteducation/content-registry-types';
import { computed, ref, withDefaults } from 'vue';
import ImageAltText from '@/components/base/ImageAltText.vue';

type Props = {
  id?: string;
  item?: ImageV1;
  forceTranslatable?: boolean;
  showButtons?: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageUploader',
  props: {
    id: { default: '' },
    item: { default: undefined },
    forceTranslatable: { type: Boolean, default: false },
    showButtons: { type: Boolean, default: true }
  },
  emits: ["input"],
  setup(__props: any, { expose, emit: emits }: { emit: ({
  (e: 'input', f: any): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { id: string, item: ImageV1, forceTranslatable: boolean, showButtons: boolean }





const file = ref<any>(null);
const cropped = ref(null);
const isChanged = ref(false);
const dialog = ref(false);
const cropModeEnabled = ref(false);
const previewImageKey = ref(new Date().getTime());
const imageAltTextComponent = ref<InstanceType<typeof ImageAltText> | null>(null);
const croppieRef = ref<any>();

const previewImage = computed(() => {
  return cropped.value ? new File([cropped.value], 'image.png', { type: 'image/png' }) : file.value;
});

const hasChanged = () => {
  return isChanged.value;
};
const defaultUpload = (overrideId?: string) => {
  const image = Array.isArray(previewImage.value) ? previewImage.value[0] : previewImage.value;
  return uploadMedia.methods.uploadMedia(overrideId || props.id, image);
};
const defaultDownload = () => {
  downloadMedia.methods.downloadMedia(props.id).then((url: string) => {
    window?.open(url, '_blank').focus();
  });
};
const croppie = (file: Blob) => {
  if (!file) {
    return;
  }

  const reader = new FileReader();
  reader.onload = (ev: any) => {
    croppieRef.value.bind({
      url: ev.target.result,
    });
  };

  reader.readAsDataURL(file);
  cropped.value = null;
};
const crop = () => {
  // Options can be updated.
  // Current option will return a base64 version of the uploaded image with a size of 600px X 450px.
  const options = {
    type: 'blob',
    size: { width: 600, height: 450 },
    format: 'png',
  };
  croppieRef.value.result(options, (output: any) => {
    cropped.value = output;
    previewImageKey.value = new Date().getTime();
    cropModeEnabled.value = false;
    dialog.value = false;
  });
};
const openDialog = () => {
  dialog.value = true;
};
const changeHandler = () => {
  if (!file.value || !file.value.length) {
    handleInputCleared();
    return;
  }

  isChanged.value = true;
  // emits('input', file.value[0]);
};
const handleInputCleared = () => {
  file.value = null;
  cropped.value = null;
  isChanged.value = false;
};
const startCroppingProcess = () => {
  cropModeEnabled.value = true;
  croppie(file.value[0]);
};
const cancelCroppingProcess = () => {
  cropped.value = null;
  cropModeEnabled.value = false;
  dialog.value = false;
};

const upload = () => {
  imageAltTextComponent.value?.saveAltText();
  return defaultUpload();
};
const download = () => {
  return defaultDownload();
};

expose({
  hasChanged,
  defaultUpload,
  defaultDownload,
  altText: imageAltTextComponent,
});

return { __sfc: true,props, emits, file, cropped, isChanged, dialog, cropModeEnabled, previewImageKey, imageAltTextComponent, croppieRef, previewImage, hasChanged, defaultUpload, defaultDownload, croppie, crop, openDialog, changeHandler, handleInputCleared, startCroppingProcess, cancelCroppingProcess, upload, download, ResourceImage, DisableableButton, uploadMedia, ImageAltText }
}

})